import { useState } from "react";
import InputTextMat from "../../../components/common/InputText/InputTextMat";
import Button from "../../../components/common/buttons/Button";
import isEmail from "validator/lib/isEmail";
import { API_ROUTES } from "../../../constants/API_ROUTES";
import NotificationDanger from "../../../components/common/Notification/NotificationDanger";
import NotificationSuccess from "../../../components/common/Notification/NotificationSuccess";
import HttpHelper from "../../../helpers/Http/HttpHelper";
import useAuth from "../../../hooks/useAuth";

const FelhasznaloHozzaadasa = ({ setIsNewUserCreated }) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [userCreateError, setUserCreateError] = useState("");
  const [userCreateSuccess, setUserCreateSuccess] = useState("");
  const { getAuth } = useAuth();
  // Auth Provider

  const validateEmail = () => {
    if (email.length < 1) {
      setEmailError("Email is required ");
      return false;
    } else if (!isEmail(email)) {
      setEmailError("Email is Invalid !");
      return false;
    } else {
      setEmailError("");
      return true;
    }
  };

  const validateName = () => {
    if (name.trim().length < 1) {
      setNameError("Name is required ");
      return false;
    } else {
      setNameError("");
      return true;
    }
  };
  const createUser = () => {
    if (validateName() && validateEmail()) {
      setUserCreateError("");
      setUserCreateSuccess("");
      const token = getAuth()?.bearerToken;
      HttpHelper.PostRequest({
        route: API_ROUTES.USER_CREATE,
        token: token,
        parameters: { name, email },
      })
        .then((res) => {
          setEmail("");
          setEmailError("");
          setName("");
          setNameError("");
          setIsNewUserCreated();
        })
        .catch((err) => {});
    }
  };
  return (
    <>
      <div className="lg:order-2 order-1 px-[1rem] sm:px-[1.875rem] overflow-x-auto w-full lg:w-1/2  lg:mt-[7.6rem]">
        <h3 className="text-text-primary-color text-[1.5rem] font-bold mb-4">
          Új felhasználó hozzáadása
        </h3>
        <div className="flex flex-col gap-[1.6rem] my-[2.5rem] mb-0">
          <InputTextMat
            label={"Név"}
            id={"name"}
            name={"name"}
            value={name}
            error={nameError}
            onChange={(e) => setName(e.target.value)}
          />

          <InputTextMat
            label={"Email"}
            id={"email"}
            name={"email"}
            value={email}
            error={emailError}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {userCreateError && <NotificationDanger message={userCreateError} />}
        {userCreateSuccess && (
          <NotificationSuccess message={userCreateSuccess} />
        )}

        <div className="pt-1 text-end">
          <Button label={`Felhasználó hozzáadása`} onClick={createUser} />
        </div>
      </div>
    </>
  );
};

export default FelhasznaloHozzaadasa;
